// extracted by mini-css-extract-plugin
module.exports = {"icon":"SortDone_icon__Y5TpL"};